"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7418],{

/***/ 77418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_SocialProofContainer; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/icons/index.tsx + 28 modules
var icons = __webpack_require__(27120);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/containers/data/SocialProofData.tsx


const SocialProofData = [{
  title: '700.000 Clienti',
  description: 'soddisfatti',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenCustomerIcon */.zx, {})
}, {
  title: '35.000 Auto',
  description: 'acquistate',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenCarIcon */.$C, {})
}, {
  title: '27 Brand',
  description: 'con cui collaboriamo',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenBrandIcon */.HL, {})
}];
/* harmony default export */ var data_SocialProofData = (SocialProofData);
;// CONCATENATED MODULE: ./src/containers/SocialProofContainer.tsx




const SocialProofList = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(6741), __webpack_require__.e(7855), __webpack_require__.e(5115)]).then(__webpack_require__.bind(__webpack_require__, 58267)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(58267)]
  }
});

const SocialProofContainer = ({
  title
}) => /*#__PURE__*/(0,jsx_runtime.jsx)(SocialProofList, {
  items: data_SocialProofData,
  title: title
});

/* harmony default export */ var containers_SocialProofContainer = (SocialProofContainer);

/***/ })

}]);